import axios from "axios";

const API_BASE = String(import.meta.env.VITE_API_BASE_URL || "").replace(/\/+$/, "");

async function request(method, path, data, config = {}) {
  try {
    const response = await axios({ method, url: `${API_BASE}${path}`, data, timeout: 90000, validateStatus: () => true, ...config });
    if (response.status >= 400 || response.data?.ok === false) {
      const error = new Error(response.data?.message || `Não foi possível concluir a operação (HTTP ${response.status}).`);
      error.status = response.status;
      error.code = response.data?.errorCode || "IPDV_REQUEST_FAILED";
      throw error;
    }
    return response.data?.data ?? response.data;
  } catch (error) {
    if (error?.status) throw error;
    if (error?.code === "ECONNABORTED") throw new Error("O servidor demorou demais para responder.");
    throw new Error(error?.response?.data?.message || "Não foi possível comunicar com o IPDV.");
  }
}

const query = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") search.set(key, String(value));
  });
  return search.toString();
};

export const fetchIpdvSnapshot = (params = {}) => request("get", `/api/ipdv/snapshot?${query(params)}`);
export const searchIpdvContacts = (params) => request("get", `/api/ipdv/egestor/contacts?${query(params)}`);
export const searchIpdvProducts = (params) => request("get", `/api/ipdv/egestor/products?${query(params)}`);
export const saveIpdvPdv = (payload) => payload.id ? request("put", `/api/ipdv/pdvs/${encodeURIComponent(payload.id)}`, payload) : request("post", "/api/ipdv/pdvs", payload);
export const saveIpdvProductMapping = (productId, payload) => request("put", `/api/ipdv/catalog/${encodeURIComponent(productId)}/mapping`, payload);
export const calculateIpdvRouteEstimate = (payload) => request("post", "/api/ipdv/routes/estimate", payload);
export const saveIpdvRoute = (payload) => payload.id ? request("put", `/api/ipdv/routes/${encodeURIComponent(payload.id)}`, payload) : request("post", "/api/ipdv/routes", payload);
export const deleteIpdvRoute = (id) => request("delete", `/api/ipdv/routes/${encodeURIComponent(id)}`);
export const generateIpdvRoute = (payload) => request("post", "/api/ipdv/routes/generate", payload);
export const startIpdvRoute = (id) => request("post", `/api/ipdv/routes/${encodeURIComponent(id)}/start`, {});
export const returnIpdvRoute = (id, payload) => request("post", `/api/ipdv/routes/${encodeURIComponent(id)}/return`, payload);
export const saveIpdvVisitDraft = (payload) => request("post", "/api/ipdv/visits/draft", payload);
export const finalizeIpdvVisit = (payload, idempotencyKey) => request("post", "/api/ipdv/visits/finalize", payload, { headers: { "Idempotency-Key": idempotencyKey } });
export const markIpdvVisitMissed = (payload) => request("post", "/api/ipdv/visits/missed", payload);
export const serveIpdvExchange = (id, payload) => request("post", `/api/ipdv/exchanges/${encodeURIComponent(id)}/serve`, payload);
